import React from 'react';
import SegmentGrid from 'src/components/segment-cdt/SegmentGrid';
import TPENavigator from 'src/components/TPENavigator';
import { makeNameLinkColumn } from 'src/components/custom-tables-shared/TableNameLinkColumn';
import { SegmentTableListRow } from 'src/models/segment-cdt/SegmentTableListRow';

/**
 * Read-only grid for the Segment Data Tables list: Name (link) · Segment Type · Owner ·
 * Last Pull. Supplies the list's column defs + Name-link navigation and renders them through the
 * shared `SegmentGrid` (which the detail data-viewer also uses). The reusable Name-link cell comes
 * from `makeNameLinkColumn`. `SegmentGrid`/`TPEReactTable` render the loading + empty states.
 */
export default function SegmentTablesGrid(props: { loading: boolean, tables: SegmentTableListRow[], tableDetailUrl: string }) {
    const { loading, tables = [], tableDetailUrl } = props;
    const [navigateURL, setNavigateURL] = React.useState('');

    // TODO(next CR): the segment detail route/view is not registered yet, so this navigation
    // currently no-matches. The Name-link wiring is kept so it works unchanged once the detail
    // page and its <Route> land in the upcoming detail CR. Safe today: the tab is flag-gated.
    const navigateToDetail = (tableId: string) => setNavigateURL(`${tableDetailUrl}/${btoa(tableId)}`);

    const columnDefinitions = React.useMemo(() => [
        makeNameLinkColumn({ navigateToDetail, accessor: 'name', idAccessor: 'tableId', header: 'Name' }),
        {
            accessor: 'segmentTypeDisplay',
            Header: () => <div className="cell-text">Segment Type</div>,
            Cell: (e: any) => <div className="cell-text">{e.value}</div>,
        },
        {
            accessor: 'owner',
            Header: () => <div className="cell-text">Owner</div>,
            Cell: (e: any) => <div className="cell-text">{e.value}</div>,
        },
        {
            accessor: 'lastPullDisplay',
            Header: () => <div className="cell-text">Last Pull</div>,
            Cell: (e: any) => <div className="cell-text">{e.value}</div>,
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
    ], []);

    return (
        <div>
            <TPENavigator path={navigateURL} />
            <SegmentGrid
                className="segmentDataTablesGrid"
                loading={loading}
                data={tables}
                columnDefinitions={columnDefinitions}
                sortable={false}
                emptyMessage="No segment data tables yet."
            />
        </div>
    );
}
